<template>
  <svg
    class="filter-icon"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12.0005 20.6998L12.6882 20.198C13.7203 19.445 14.3306 18.2443 14.3306 16.9667V14.6298C14.3306 13.9198 14.7306 13.0098 15.1406 12.5098L19.7806 8.46976C20.2906 7.95976 20.6906 7.05977 20.6906 6.44977V5.50977C20.6906 4.4052 19.7951 3.50977 18.6906 3.50977H12.0005H5.31055C4.20598 3.50977 3.31055 4.4052 3.31055 5.50977V6.44977C3.31055 7.05977 3.71052 7.95976 4.22052 8.46976L8.86055 12.5098C9.27055 13.0098 9.67054 13.9198 9.67054 14.6298V18.9798C9.67054 20.5998 10.6905 21.5098 12.0005 20.6998Z"
      :fill="filled ? 'currentColor' : 'none'"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    filled?: boolean;
  }>(),
  {
    filled: false,
  },
);
</script>

<style scoped>
.filter-icon {
  width: 24px;
  height: 24px;
  display: block;
  flex-shrink: 0;
}
</style>
